import { assertEx, EthAddress } from '@xylabs/sdk-js'
import { BaseJsonObject, XyoWorldBase, XyoWorldGeotokens } from '@xyo-network/sdk-xyoworld-js'

import EntityGeotokens, { XyoWorldEntityGeotokensJsonObject } from './XyoWorldEntityGeotokens'

enum EntityType {
  All = 'all',
  Bidder = 'bidder',
  Owner = 'owner',
  Player = 'player',
}

interface EntityJsonObject extends BaseJsonObject {
  address: string
  geotokens?: XyoWorldEntityGeotokensJsonObject
}

class XyoWorldEntity extends XyoWorldBase<EntityJsonObject> {
  public address: EthAddress
  public geotokenList?: EntityGeotokens
  private geotokens?: XyoWorldGeotokens | null

  constructor(address: EthAddress, geotokens?: XyoWorldGeotokens | null) {
    super()
    this.geotokens = geotokens
    this.address = address
  }

  public getGeotokenList() {
    if (this.geotokens) {
      this.geotokenList = this.geotokenList ?? new EntityGeotokens(this.address, this.geotokens)
      return this.geotokenList
    }
  }

  loadJsonObject(jsonObject?: EntityJsonObject) {
    if (jsonObject) {
      this.address = assertEx(EthAddress.fromString(jsonObject.address), 'Bad address')
      this.getGeotokenList()?.loadJsonObject(jsonObject.geotokens)
    }
    return this
  }

  toJsonObject(): EntityJsonObject {
    return {
      address: this.address.toString(),
      geotokens: this.getGeotokenList()?.toJsonObject(),
    }
  }
}

export { EntityType, XyoWorldEntity }
export type { EntityJsonObject }
